module.exports = __webpack_public_path__ + "images/emoji/no_smoking.a3fe41057eee8a0b27da.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/no_smoking.png
// module id = JawH
// module chunks = 2